// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1lW7t","image":"Header_image__3Cboo","name":"Header_name__yTR1v","info":"Header_info__24BEv","infoRow":"Header_infoRow__1EPpf"};